<!-- Footer -->
  <div class="d-flex justify-content-center">
    <p class="clearfix mb-0">
      <span class="float-md-left d-block d-md-inline-block mt-25">
        COPYRIGHT &copy; {{ year }}
        <a class="ml-25" href="https://www.goalngo.com/" target="_blank"
          >GOALNGO INC</a
        >
        <span class="d-none d-sm-inline-block">, All rights Reserved</span>
      </span>
      <!-- <span class="float-md-right d-none d-md-block">
        Hand-crafted & Made with
        <span [data-feather]="'heart'" [class]="'pink'"></span>
      </span> -->
    </p>
  </div>
<!--/ Footer -->

<!-- Move to top Button-->
<app-scroll-top *ngIf="coreConfig.layout.scrollTop"></app-scroll-top>

<!-- Buynow Button-->
